import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SurveyForm from './components/SurveyForm';
import Results from './components/Results';
import UserResults from './components/UserResults';
import CompanyResults from './components/CompanyResults';
import Submitted from './components/Submitted';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import { ToastProvider } from './components/ToastProvider';

function App() {
  return (
    <ToastProvider>
      <div className="min-h-screen bg-gradient-to-br from-white-600 via-grey-600 to-grey-800">
        <Routes>
          <Route path="/" element={<SurveyForm />} />
          <Route path="/submitted/:encodedSubmissionId" element={<Submitted />} />
          <Route path="/results/:submissionId" element={<UserResults />} />
          <Route path="/company-portfolio/:domainName" element={<CompanyResults />} />
          <Route path="/internal/results/:submissionId" element={<Results />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </div>
    </ToastProvider>
  );
}

export default App;